import React from "react";
import "./styles.scss";
import "./mobile.scss";
import PropTypes from "prop-types";
import { GetIconByName } from "../../config/icon";

const Index = ({ data, onChange, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      {!data.isLoading && (
        <button
          className={`btn-wrapper ${data.mainLayerStyles} ${data.style} ${data.buttonType} ${data.disable} ${data.buttonSize} 
        ${data.option}`}
          type={data.type}
          disabled={data.disable}
          onClick={!data.disable ? onClick : null}
        >
          <div className="d-flex justify-content-center align-content-center align-items-center">
            <>
              {data.btnName !== "" && (
                <div className={`btn__fill ${data.innerStyle}`}>
                  {data.btnName}{" "}
                </div>
              )}
              {(data.buttonIcon || data.showMore) && (
                <>
                  <div className={`btn__icon ${data.btnName ? "ml-1" : ""}`}>
                    {data.btnIcon}
                  </div>
                </>
              )}
            </>
          </div>
        </button>
      )}

      {data.isLoading && (
        <button
          className={`btn-wrapper loading ${data.buttonType} ${data.disable} ${
            data.buttonSize === "md-x"
              ? data.buttonSize + " pb-4"
              : data.buttonSize
          }`}
          type={data.type}
        >
          <div className="d-flex justify-content-center align-content-center align-items-center">
            <div className={`spinner-loader`} />
            {/* <div className={"btn__fill d-flex"}>Loading...</div> */}
          </div>
        </button>
      )}
    </>
  );
  return (
    <React.Fragment>
      <>{inputElement}</>
    </React.Fragment>
  );
};
Index.propTypes = {
  buttonType: PropTypes.string,
  buttonSize: PropTypes.string,
};

Index.defaultdata = {
  buttonType: "primary",
  buttonSize: "md",
};

export default Index;
